import { createAction } from "@reduxjs/toolkit"

const PREFIX = "auth/"
const SET_CURRENT_USER = `${PREFIX}SET_CURRENT_USER`

export const setCurrentUser = createAction<any>(SET_CURRENT_USER)
